module.exports = __webpack_public_path__ + "img/icon_utill_us.c0a35c67.svg";